//Drawing the arrow up/down which shows whether or not the group is expanded
import {cacheManager} from './canvas_timeline_cache_manager';
import {COMMON_IMAGE} from './canvas_timeline_util';

const drawExpansionImageIcon = (context, x, y, width, height, options = {}) => {
	//x, y, width, height are values describing the group, not measurements of the icon itself
	const icon = options && options.expanded ? cacheManager.getCommonImage(COMMON_IMAGE.COLLAPSE) : cacheManager.getCommonImage(COMMON_IMAGE.EXPAND);
	if (!icon) {
		return;
	}
	const iconWidth = 10;
	const iconHeight = 6;
	let xCenter;
	if (options.align === 'left') {
		xCenter = x + iconWidth / 2 + 16; //16 margin left
	} else {
		xCenter = x + width - iconWidth / 2 - 16; //16 margin right
	}
	const yCenter = y + height / 2;
	const xDiff = iconWidth / 2;
	const yDiff = iconHeight / 2;
	context.drawImage(icon, xCenter - xDiff, yCenter - yDiff, iconWidth, iconHeight);
};

//Drawing the double arrow down icon for expand all
const drawExpandAllImageIcon = (context, x, y, width, height, options = {}) => {
	//x, y, width, height are values describing the group, not measurements of the icon itself
	const icon = options && options.expanded ? cacheManager.getCommonImage(COMMON_IMAGE.COLLAPSE_ALL) : cacheManager.getCommonImage(COMMON_IMAGE.EXPAND_ALL);
	if (!icon) {
		return;
	}
	const iconWidth = 10;
	const iconHeight = 10;
	let xCenter;
	if (options.align === 'left') {
		xCenter = x + icon.width / 2 + 16; //16 margin left
	} else {
		xCenter = x + width - icon.width / 2 - 16; //16 margin right
	}
	const yCenter = y + height / 2;
	const xDiff = icon.width / 2;
	const yDiff = icon.height / 2;

	context.drawImage(icon, xCenter - xDiff, yCenter - yDiff, iconWidth, iconHeight);
};

module.exports = {
	drawExpansionImageIcon,
	drawExpandAllImageIcon,
};
